import { trackEvent } from './trackEvent';

/**
 * AB test tracking for user AB tests
 * @param {object} abTestData An object containing
 * @param {string} abTestData.testName
 * @param {boolean} abTestData.isInVariant whether the user is in the control or variant bucket
 * @param {number} abTestData.variantPercentage percentage of users that currently receive the variant treatment
 */
export function trackUserAbTestEvent({
    testName,
    isInVariant,
    variantPercentage,
}: {
    testName: string;
    isInVariant: boolean;
    variantPercentage: number;
}): void {
    trackEvent({
        category: 'a/b testing v2',
        action: testName,
        label: isInVariant ? 'variant' : 'control',
        value: variantPercentage,
    });
}
